import { useAuth } from "@spiriidk/auth";
import { BETA_FEATURES_STORAGE_KEY } from "@spiriidk/connect-configs";
import { useLocalStorageSync } from "@spiriidk/utils";
import React, { type ReactNode } from "react";

import { BetaFeaturesContext } from "./beta-features-context";

function BetaFeaturesProvider({ children }: { children: ReactNode }) {
  const { permittedBetaTest } = useAuth();
  const [isBetaEnabled, setIsBetaEnabledStorage] = useLocalStorageSync<boolean>(
    {
      key: BETA_FEATURES_STORAGE_KEY,
      defaultValue: permittedBetaTest,
      serialize: (value) => String(value),
      deserialize: (value) => value === "true",
    }
  );

  return (
    <BetaFeaturesContext.Provider
      value={{
        // for cases if in LS we have true,
        // but at some point we disabled beta feature for a user in keycloak
        isBetaEnabled: permittedBetaTest && isBetaEnabled,
        // sync is done via useLocalStorageSync
        setIsBetaEnabled: setIsBetaEnabledStorage,
      }}
    >
      {children}
    </BetaFeaturesContext.Provider>
  );
}

export { BetaFeaturesProvider };
